import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { Button } from "@progress/kendo-react-buttons";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import AlertBox from "../../components/common/AlertBox";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import { Switch } from "@progress/kendo-react-inputs";
import AppDrawer from "../../components/drawer/Drawer";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import ButtonEdit from "../../components/drawer/ButtonEdit";
import { ACTIVEINACTIVE_TYPE } from "../../_contstants/common";
import {
  InquirySubtypeActiveInactive,
  deleteInquirySubtype,
  getAllInquirySubtype,
} from "./services/inquireysubtype.services";
import CreateInquirySubType from "./CreateInquirySubType";
import {
  clearInquirySubTypeID,
  setInquirySubTypeID,
} from "./inquirysubtypeSlice";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import { checkAcessRights } from "../../_helper/helper";

const InquirySubtype: React.FC = () => {
  const dispatch = useAppDispatch();
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  useEffect(() => {
    dispatch(getAllInquirySubtype());
    return () => {
      dispatch(closeDialog());
    };
  }, []);
  return (
    <>
      <DeleteInquirySubTypeDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Inquiry Sub Type List
          </Typography.h4>
          {isAddAccess && (
            <ButtonCreate
              label="Create Inquiry Sub Type"
              drawerName="InquirySubTypeForm"
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <InquiryTypeGridComponent />
        </GridLayoutItem>
        {isDrawerOpen && drawerName === "InquirySubTypeForm" && (
          <AppDrawer>
            <CreateInquirySubType />
          </AppDrawer>
        )}
      </GridLayout>
    </>
  );
};

/* This function is called when the delete button is clicked */
const DeleteInquirySubTypeDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const InquirySubtypeID = useAppSelector(
    (state) => state.inquirysubtype?.InquirySubtypeID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteInquirySubtype(ID));
      if (response.payload?.Data.Status === 200) {
        dispatch(getAllInquirySubtype());
        dispatch(closeDialog());
        dispatch(clearInquirySubTypeID());
      } else {
        dispatch(getAllInquirySubtype());
        dispatch(closeDialog());
        dispatch(clearInquirySubTypeID());
      }
    }
  };

  return (
    <>
      {dialogName === "DeleteInquirysubType" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Inquiry Sub Type?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Inquiry Sub Type?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(InquirySubtypeID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const InquiryTypeGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const InquirySubtypeList = useAppSelector(
    (state) => state.inquirysubtype.InquirySubtypeList
  );
  const loading = useAppSelector((state) => state.inquirysubtype.loading);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? InquirySubtypeList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("DeleteInquirysubType"));
      dispatch(setInquirySubTypeID(ID));
    };
    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <ButtonEdit
            ID={props.dataItem.InquirySubTypeGUID}
            drawerName="InquirySubTypeForm"
            title="Edit"
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
themeColor="error"
            onClick={() =>
              handleOpenDeleteDialog(props.dataItem.InquirySubTypeGUID)
            }
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.IsActive);
    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        InquirySubTypeGUID: props.dataItem.InquirySubTypeGUID,
        IsActive: !IsActive,
        OperationType: ACTIVEINACTIVE_TYPE,
      };
      dispatch(InquirySubtypeActiveInactive(data)).then((response: any) => {
        if (response.payload?.Status === 200) {
          dispatch(getAllInquirySubtype());
        } else {
          dispatch(getAllInquirySubtype());
        }
      });
    };

    return (
      <td style={{ textAlign: "center" }}>
        <Switch
          name="IsActive"
          checked={IsActive}
          disabled={isEditAccess ? false : true}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <>
      {InquirySubtypeList && InquirySubtypeList.length ? (
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
 className="responsive-table"
          filterable={true}
          filter={filter}
          data={
            filter
              ? filterBy(InquirySubtypeList, filter).slice(
                  page.skip,
                  page.take + page.skip
                )
              : InquirySubtypeList.slice(page.skip, page.take + page.skip)
          }
          onFilterChange={handleFilterChange}
          skip={page.skip}
          take={page.take}
          total={InquirySubtypeList.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [5, 10, 15, "All"],
            pageSizeValue: pageSizeValue,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="InquirySubType"
            title="Inquiry Sub Type"
            cell={(props: any) => (
              <td className="hoverableName">
                {isEditAccess ? (
                  <ButtonEdit
                    ID={props.dataItem.InquirySubTypeGUID}
                    drawerName="InquirySubTypeForm"
                    label={props.dataItem?.InquirySubType}
                  />
                ) : (
                  props.dataItem?.InquirySubType
                )}
              </td>
            )}
          />
          <Column field="InquiryType" title="Inquiry Type" />
          <Column
            field="InquirySubTypeGUID"
            title="Status"
            cell={MyActiveInActtiveCommandCell}
            width={"90px"}
            filterable={false}
            locked={true}
          />
          {(isDeleteAccess || isEditAccess) && (
            <Column
              field="InquirySubTypeGUID"
              title="Actions"
              cell={MyEditCommandCell}
              width={"110px"}
              filterable={false}
            />
          )}
        </KendoGrid>
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default InquirySubtype;
